import React from 'react';

import {
    List,
    ListItem, Tooltip,
} from '@material-ui/core';
import {isMobileBrowser} from "../vendors/utils/common";
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';

const defaultTheme = createMuiTheme();

const theme = createMuiTheme({
    overrides: {
        MuiTooltip: {
            popper: {
                maxWidth: '18rem',
            },
            tooltip: {
                padding: 0,
                backgroundColor: '#ffffff',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'var(--consumer-purple)',
                color: 'var(--consumer-purple)',
                borderRadius: '0.625rem',
                position: 'relative',

                '&:before': {
                    content: '""',
                    position: 'absolute',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'transparent',
                    top: '14px',
                    height: '13px',
                    width: '13px',
                    right: '-7px',
                    borderLeftWidth: '0',
                    borderRightColor: 'var(--consumer-purple)',
                    borderTopColor: 'var(--consumer-purple)',
                    transform: 'rotate(45deg)',
                    backgroundColor: '#ffffff'
                },

                [defaultTheme.breakpoints.down('sm')]: {
                    '&:before': {
                        content: '""',
                        position: 'absolute',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'transparent',
                        top: 'unset',
                        right: 'unset',
                        height: '13px',
                        width: '13px',
                        bottom: '-7px',
                        left: '30px',
                        borderLeftWidth: '0',
                        borderRightColor: 'var(--consumer-purple)',
                        borderTopColor: 'var(--consumer-purple)',
                        transform: 'rotate(133deg)',
                        backgroundColor: '#ffffff'
                    },
                }
            },
        }
    }
});

interface Default {
    options: {
        n?: boolean,
        u?: boolean,
        l?: boolean,
        min?: boolean
    }
}


const PasswordInfoWindow: React.FC<Default> = (props: Default) => {

    const {options: {n: number, u: upper, l: lower, min}} = props;

    return (
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <Tooltip
                    PopperProps={{
                        disablePortal: false,
                        modifiers: {
                            flip: {
                                enabled: false,
                            }
                        }

                    }}
                    placement={isMobileBrowser() ? "top-start" : "left"}
                    open={number || upper || lower || min}
                    disableHoverListener
                    title={
                        <div className="password-info-window-wrapper">
                            <List className="text-left">
                                <ListItem>
                                    <div className="align-box-row align-items-start">
                                        The password must be at least 8 characters long:
                                    </div>
                                </ListItem>
                                {upper && <ListItem>
                                    <div className="align-box-row align-items-start">
                                        -uppercase
                                    </div>
                                </ListItem>}
                                {lower && <ListItem>
                                    <div className="align-box-row align-items-start">
                                        -lowercase
                                    </div>
                                </ListItem>}
                                {number && <ListItem>
                                    <div className="align-box-row align-items-start">
                                        -number
                                    </div>
                                </ListItem>}
                            </List>
                        </div>
                    }>
                    <span/>
                </Tooltip>
            </ThemeProvider>


        </React.Fragment>);
};


export default PasswordInfoWindow;

